import { get } from "lodash-es";
export function isOffline() {
  return !!get(window, 'xy_is_offline');
}
//# sourceMappingURL=offline.js.map
